import { render, staticRenderFns } from "./FakturPajak.vue?vue&type=template&id=2b3d9fe4&scoped=true"
import script from "./FakturPajak.vue?vue&type=script&lang=js"
export * from "./FakturPajak.vue?vue&type=script&lang=js"
import style0 from "./FakturPajak.vue?vue&type=style&index=0&id=2b3d9fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d9fe4",
  null
  
)

export default component.exports